var inline = false;
function inlineMock(nextInline) {
  if (typeof nextInline === 'boolean') {
    inline = nextInline;
  }
  return inline;
}
export { inline, inlineMock };
//# sourceMappingURL=mock.js.map
